import { Component, OnInit } from '@angular/core';
import { ConfigServiceService } from 'src/app/services/config-service.service';

@Component({
  selector: 'app-restriction',
  templateUrl: './restriction.component.html',
  styleUrls: ['./restriction.component.scss']
})
export class RestrictionComponent implements OnInit {
  coursePopupTitle: any = 'Upgrade Your Plan';
  coursePopupDescriptionContent: any = 'Upgrade to the premium plan for additional features.';

  constructor(
    private configService: ConfigServiceService,
  ) { }

  ngOnInit() {

    this.getConfigData();

  }

  showPopup = false;

  getConfigData() {
    this.configService.getConfigData()
      .subscribe(
        data => {
          this.coursePopupTitle=data['coursePopupTitle'];
          this.coursePopupDescriptionContent=data['coursePopupDescriptionContent'];
        }, error => {

        }
      );
  }

  closePopup() {
    this.showPopup = false;
  }

}

